import cn from 'classnames';
import { memo, useEffect, useState, type ReactNode } from 'react';
import { Stack } from '@mui/material';
import { ArrowIosLeft } from '@shared/assets/index';
import { SAccordion, SBody, STitle } from '@shared/ui/layout/accordion/styles';

export type AccordionPT = {
  title: string;
  titleClassName?: string;
  bodyClassName?: string;
  bodyClassNameOnOpen?: string;
  closeArrowClassName?: string;
  children?: ReactNode;
  className?: string;
  isAlwaysOpen?: boolean;
  isOpenInit?: boolean;
  headerChildrenOnClose?: ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
};

export const Accordion = memo(
  ({
    title,
    children,
    className,
    isAlwaysOpen = false,
    isOpenInit = false,
    titleClassName,
    bodyClassName,
    bodyClassNameOnOpen,
    closeArrowClassName,
    headerChildrenOnClose,
    onClose,
    onOpen,
  }: AccordionPT) => {
    const [isOpen, setIsOpen] = useState(isAlwaysOpen || isOpenInit);
    const changeAccordionState = () => {
      !isAlwaysOpen &&
        setIsOpen((isOpen) => {
          isOpen ? onClose?.() : onOpen?.();
          return !isOpen;
        });
    };

    useEffect(() => {
      isOpenInit && !isOpen && setIsOpen(true);
    }, [isOpenInit]);

    return (
      <SAccordion className={className}>
        <STitle onClick={changeAccordionState} $isOpen={isOpen} className={titleClassName}>
          {title}

          <Stack direction={'row'} alignItems={'center'} ml={'auto'} gap={'5px'}>
            {!isOpen && headerChildrenOnClose}
            {!isAlwaysOpen && <ArrowIosLeft className={closeArrowClassName} />}
          </Stack>
        </STitle>

        <SBody $isOpen={isOpen} className={cn(bodyClassName, isOpen && bodyClassNameOnOpen)}>
          {children}
        </SBody>
      </SAccordion>
    );
  }
);
